<div class="sub-answer__label">
    <label class="sub-answer__labelText" [innerHtml]="subquestion.libelle"> </label>
</div>
<div class="sub-answer__input">
    <input
        [id]="subquestion.id + '-' + controlId"
        type="text"
        [formControl]="myControl"
        [matAutocomplete]="auto"
        [placeholder]="subquestion.listeReference"
        class="textfield textfield--full angucomplete-input angucomplete-input--neutral"
        [maxLength]="maxCharCounter - charCounter + (myControl.value ? myControl.value.length : 0)"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{ option.libelle }}
        </mat-option>
    </mat-autocomplete>
</div>
<div class="sub-answer__charCounter" [ngClass]="{ 'sub-answer__charCounter-error': charCounter > maxCharCounter }">
    <div *ngIf="charCounter <= maxCharCounter">{{ maxCharCounter - charCounter }} {{ 'medicalworkflow.question.caracteresRestants' | i18n }}</div>
    <div *ngIf="charCounter > maxCharCounter">
        {{ 'medicalworkflow.question.limiteCaracteresDepassee' | i18n }}
    </div>
</div>
